export default "__VITE_ASSET__7ac11158__"